import React from 'react';
import { PanelAnchor, PanelLink, Tile, TileAnchor } from './CategoryMegaNav.styles';
import type { ResolvedMegaNavLink } from './useResolvedMegaNav';

type MegaNavLinkProps = Readonly<{
  link: ResolvedMegaNavLink;
  /** `text` = a row in a column; `tile` = an imagery tile. */
  variant?: 'text' | 'tile';
  onClick: () => void;
  children: React.ReactNode;
}>;

/**
 * The one place that decides how a resolved nav destination is rendered: a router
 * `Link` for SPA routes (keeps flag overrides on the URL), a plain anchor otherwise.
 * Shared by the desktop panel and the mobile sheet so the two never drift.
 */
export const MegaNavLink = ({ link, variant = 'text', onClick, children }: MegaNavLinkProps) => {
  if (variant === 'tile') {
    return link.isSpaRoute ? (
      <Tile
        to={link.href}
        onClick={onClick}
      >
        {children}
      </Tile>
    ) : (
      <TileAnchor
        href={link.href}
        onClick={onClick}
      >
        {children}
      </TileAnchor>
    );
  }
  return link.isSpaRoute ? (
    <PanelLink
      to={link.href}
      onClick={onClick}
    >
      {children}
    </PanelLink>
  ) : (
    <PanelAnchor
      href={link.href}
      onClick={onClick}
    >
      {children}
    </PanelAnchor>
  );
};
